import { InitiativeStatus } from 'legacy/lut/classes/models/partner360/IFormThingsToImprove'

import { KeyInitiative } from 'partner360/entities/keyInitiatives'

import { IDescriptionQualityCheckResult } from '../model/types'

export type TKeyInitiativeCopyPayload = Partial<KeyInitiative> & {
  PreviousEntryId: number
}

export const buildCopiedKeyInitiative = (
  source: KeyInitiative,
  descriptionQuality: IDescriptionQualityCheckResult
): TKeyInitiativeCopyPayload => ({
  PreviousEntryId: source.EntryId,
  IsNotApplicable: source.IsNotApplicable,
  Name: source.Name,
  NameExt: source.NameExt,
  Description: source.Description,
  Development: source.Development,
  Status: InitiativeStatus.New,
  Period: source.Period,
  HPInvestmentSum: source.HPInvestmentSum,
  HPInvestmentSource: source.HPInvestmentSource,
  IsFromGlobalPartner: source.IsFromGlobalPartner,
  Comment: source.Comment,
  ActivityType: source.ActivityType,
  BusinessPriorities: source.BusinessPriorities,
  KeyObjectiveTags: source.KeyObjectiveTags,
  DescriptionQuality: JSON.stringify({
    Score: descriptionQuality.score,
    Reasons: descriptionQuality.reasons,
  }),
  FocusArea: source.FocusArea,
  Owner: source.Owner,
  Products: source.Products,
  DataInsightRelated: source.DataInsightRelated,
  Category: source.Category,
  GoalDescription: source.GoalDescription,
  IsAchieved: source.IsAchieved,
  ProofOfExecution: source.ProofOfExecution,
  InitType: source.InitType,
  AddToBridges: source.AddToBridges,
  BusinessUnit: source.BusinessUnit,
  PracticeBuilder: source.PracticeBuilder,
  CurrentProgress: source.CurrentProgress,
  FollowUp: source.FollowUp,
  Currency: source.Currency,
  ValueType: source.ValueType,
  Outcome: source.Outcome,
  OutcomeValueType: source.OutcomeValueType,
  FunnelSize: source.FunnelSize,
  Leads: source.Leads,
  ConversionRate: source.ConversionRate,
  Attendance: source.Attendance,
  GoalNdp: source.GoalNdp,
  GoalNdpUSD: source.GoalNdpUSD,
  GoalNdpLocalCurrency: source.GoalNdpLocalCurrency,
  GoalNet: source.GoalNet,
  GoalNetUSD: source.GoalNetUSD,
  GoalNetLocalCurrency: source.GoalNetLocalCurrency,
  GoalTNet: source.GoalTNet,
  GoalTNetUSD: source.GoalTNetUSD,
  GoalTNetLocalCurrency: source.GoalTNetLocalCurrency,
  GoalUTNet: source.GoalUTNet,
  GoalUTNetUSD: source.GoalUTNetUSD,
  GoalUTNetLocalCurrency: source.GoalUTNetLocalCurrency,
  IncrementalNdp: source.IncrementalNdp,
  IncrementalNdpUSD: source.IncrementalNdpUSD,
  IncrementalNdpLocalCurrency: source.IncrementalNdpLocalCurrency,
  IncrementalNet: source.IncrementalNet,
  IncrementalNetUSD: source.IncrementalNetUSD,
  IncrementalNetLocalCurrency: source.IncrementalNetLocalCurrency,
  IncrementalTNet: source.IncrementalTNet,
  IncrementalTNetUSD: source.IncrementalTNetUSD,
  IncrementalTNetLocalCurrency: source.IncrementalTNetLocalCurrency,
  IncrementalUTNet: source.IncrementalUTNet,
  IncrementalUTNetUSD: source.IncrementalUTNetUSD,
  IncrementalUTNetLocalCurrency: source.IncrementalUTNetLocalCurrency,
  Justification: source.Justification,
  CountriesAffectedList: source.CountriesAffectedList,
  IsCountriesAffected: source.IsCountriesAffected,
})
